// extracted by mini-css-extract-plugin
module.exports = {"newscontent-box":"eM","newscontentBox":"eM"};